import { useStatusOverlay } from '@fs/zion-ui'
import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import notifySentry from '../lib/helpers/sentryNotifier'

const alwaysNotify = () => true

export default function useErrorHandlerOverlay(error, shouldNotify = alwaysNotify) {
  const showStatusOverlay = useStatusOverlay()
  const [t] = useTranslation()

  // Read through a ref instead of depending on shouldNotify directly: an inline predicate gets
  // a new identity every render, which would otherwise re-fire this effect (and the toast) on
  // every render for as long as `error` stays set.
  const shouldNotifyRef = useRef(shouldNotify)
  shouldNotifyRef.current = shouldNotify

  useEffect(() => {
    if (!error) {
      return
    }

    notifySentry(error)

    if (shouldNotifyRef.current(error)) {
      showStatusOverlay({
        message: t(
          'generic.api.error.message',
          'We’re sorry, but there’s an issue loading the content. Please try again shortly while we investigate.'
        ),
        type: 'error',
        dismissable: true,
      })
    }
  }, [error, showStatusOverlay, t])
}
